<template>
  <b-sidebar
    id="sidebar-transaction-filters"
    sidebar-class="sidebar-lg"
    :visible="isFilterSidebarActive"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-filter-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Filters
        </h5>
        <feather-icon
          class="cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <div class="px-2 py-1">
        <b-form-group label="Related Record">
          <b-form-checkbox
            :checked="relatedRecordCheckAll"
            :indeterminate="relatedRecordIndeterminate"
            @change="toggleRelatedRecordAll"
          >
            All
          </b-form-checkbox>
          <b-form-checkbox-group
            v-model="selectedRelatedRecords"
            stacked
          >
            <b-form-checkbox
              v-for="option in relatedRecordOptions"
              :key="option"
              :value="option"
            >
              {{ option }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <hr>

        <b-form-group
          label="Transaction Date"
          label-for="transaction-date"
        >
          <b-input-group>
            <flat-pickr
              id="transaction-date"
              v-model="transactionDate"
              placeholder="Today"
              class="form-control flat-pickr-group"
              :config="{ wrap: true, dateFormat: 'd/m/Y', disableMobile: true }"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                data-toggle
                size="16"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group
          label="Payment Mode"
          label-for="payment-mode"
        >
          <v-select
            v-model="paymentMode"
            input-id="payment-mode"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="paymentModeOptions"
            placeholder="Select from list"
          />
        </b-form-group>

        <b-form-group
          label="Amount Range"
          label-for="amount-range"
        >
          <v-select
            v-model="amountRange"
            input-id="amount-range"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="amountRangeOptions"
            placeholder="Select from list"
          />
        </b-form-group>

        <b-form-group
          label="Processed By"
          label-for="processed-by"
        >
          <v-select
            v-model="processedBy"
            input-id="processed-by"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="processedByOptions"
            placeholder="Select from list"
          />
        </b-form-group>
      </div>

      <!-- Footer -->
      <div class="d-flex content-sidebar-footer px-2 py-1">
        <b-button
          variant="outline-primary"
          class="mr-1"
          @click="clearAll"
        >
          Clear all
        </b-button>
        <b-button
          variant="primary"
          @click="applyFilter(hide)"
        >
          Apply filter
        </b-button>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BButton, BFormGroup, BFormCheckbox, BFormCheckboxGroup, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BSidebar,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  model: {
    prop: 'isFilterSidebarActive',
    event: 'update:is-filter-sidebar-active',
  },
  props: {
    isFilterSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      relatedRecordOptions: ['Retail Order', 'Sales Submission', 'Sales Order', 'File Payment'],
      paymentModeOptions: ['Card', 'Cash', 'GIRO', 'NETS', 'Cheque', 'GrabPay', 'PayNow', 'Bank Transfer'],
      amountRangeOptions: ['Below $500', '$500 - $1,000', '$1,000 - $5,000', 'Above $5,000'],
      processedByOptions: ['Admin name'],

      selectedRelatedRecords: [],
      transactionDate: '',
      paymentMode: null,
      amountRange: null,
      processedBy: null,
    }
  },
  computed: {
    relatedRecordCheckAll() {
      return this.selectedRelatedRecords.length === this.relatedRecordOptions.length
    },
    relatedRecordIndeterminate() {
      return this.selectedRelatedRecords.length > 0 && !this.relatedRecordCheckAll
    },
  },
  methods: {
    toggleRelatedRecordAll(checked) {
      this.selectedRelatedRecords = checked ? [...this.relatedRecordOptions] : []
    },
    clearAll() {
      this.selectedRelatedRecords = []
      this.transactionDate = ''
      this.paymentMode = null
      this.amountRange = null
      this.processedBy = null
    },
    applyFilter(hide) {
      this.$emit('apply-filter', {
        relatedRecords: this.selectedRelatedRecords,
        transactionDate: this.transactionDate,
        paymentMode: this.paymentMode,
        amountRange: this.amountRange,
        processedBy: this.processedBy,
      })
      hide()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss" scoped>
.content-sidebar-footer {
  position: sticky;
  bottom: 0;
  background-color: inherit;
  border-top: 1px solid #EBE9F1;
}
</style>
